module.exports = __webpack_public_path__ + "img/finance_15.59433197.png";